module.exports = __webpack_public_path__ + "images/emoji/shower.41ff3c7ad0f241ecdb39.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/shower.png
// module id = c+uK
// module chunks = 24